import api from "@/config/api";
import { useAdmin } from "@/context/admin";
import { Brand } from "@/types/entities";
import { log } from "@/utils/logger";
import { isDefined } from "@/utils/validations";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

const useQueryBrands = (orgId?: string) => {
    const authenticated = useAdmin(state => state.authenticated);
    const { oid } = useParams();

    const organizationID = orgId || oid;

    const enabled = authenticated && isDefined(organizationID);

    const getBrands = async () => {
        try {
            const data = await api.get<Array<Brand>>(`/organizations/${organizationID}/brands`);
            return data;
        } catch (e) {
            log.error(e);
        }
    };

    return useQuery({ queryKey: ["brands", organizationID], queryFn: getBrands, enabled });
};

export default useQueryBrands;
